<h4 class="text-center" *ngIf="!pdfSrc">Aguarde...</h4>

<pdf-viewer
  *ngIf="data.mimetype === 'application/pdf'"
  [src]="pdfSrc"
  [render-text]="true"
  [original-size]="false"
  style="width: 50vw; height: 50vh; overflow: none"
></pdf-viewer>

<img
  *ngIf="data.mimetype !== 'application/pdf'"
  [src]="pdfSrc"
  class="img-fluid"
  style="width: 30vw; height: 70vh; overflow: none"
/>
